export { createPagesApi } from './API/pagesAPI';
export type { IPagesAPI } from './API/pagesAPI';
